<div id="main-wrapper" class="min-vh-100 d-flex align-items-center justify-content-center">
  <div class="row h-100 w-100">
    <!-- <div class="col-lg-6 d-lg-flex align-items-center justify-content-center login-set-bg pe-0">
      <div class="login-content">
        <h2>Specialists in R&D Tax and other innovation incentives</h2>
        <p>
          The UK Government has committed to raising investment in Research and
          Development (R&D) to 2.4% of Gross Domestic Product (GDP) by 2027. To
          further this objective, generous tax relief and grant funding schemes
          are available for companies undertaking research and development.
        </p>
        <p>
          iTax Advisors Limited is a specialist innovation tax consultancy
          focused solely on assisting UK companies in harnessing these
          government incentives.
        </p>
        <div class="video-btn">
          <button class="btn btn-primary">
            <span>Video</span>
            <img src="../../../assets/Krid/img/video-icon.svg" alt="" />
          </button>
        </div>
      </div>
    </div> -->
    <div class="col-lg-12 px-0">
      <div class="pattern-design d-flex align-items-center justify-content-center">
        <div class="row d-flex flex-column justify-content-center">
          <div class="col-lg-12 col-12 m-auto d-flex justify-content-center">
            <div class="p-3">
              <div class="mb-4 mt-3 mt-lg-0">
                <img src="../../../assets/Krid/img/main-logo.svg" class="m-auto d-table logo" alt="" />
              </div>
              <div class="heading">
                <h2>Forgot Password</h2>
                <p>Enter your email for password recovery.</p>
              </div>
              <form [formGroup]="forgotPassWordForm" class="form" (ngSubmit)="submitForgotPassForm()">
                <div class="form-group">
                  <label>{{ labelConstants.Email
                    }}<span class="text-danger">*</span>
                  </label>
                  <div class="input-group mb-1">
                    <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                    <input type="Email" oninput="this.value = this.value.replace(/^\s+/g, '')"
                      oninput="this.value = this.value.toLowerCase()" formControlName="UserEmail"
                      placeholder="Enter your email" class="form-control" maxlength="100" />
                  </div>
                  <span class="text-danger"
                    *ngIf="submitted && EmailFormValidations['UserEmail'].errors?.['required']">{{
                    errorMessages.EmalRequired }}</span>
                  <span class="text-danger"
                    *ngIf="submitted && EmailFormValidations['UserEmail'].errors?.['pattern']">{{
                    errorMessages.EmailNotValid }}</span>
                </div>
                <div class="form-group">
                  <button type="submit" [disabled]="!forgotPassWordForm.valid || isLoading"
                    class="btn login-btn mt-3 mb-3" [ngClass]="{ loading: isLoading }">
                    <span *ngIf="!isLoading">{{
                      labelConstants.SendLink
                      }}</span>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                  </button>
                </div>
                <div class="form-group d-flex align-items-center justify-content-center back-text">
                  <a class="mt-3 mb-3 text-center d-block back-login" type="submit" routerLink="/"><i
                      class="fa-solid fa-arrow-left me-4"></i>{{ labelConstants.BackToLogin }}</a>
                </div>
                <input type="hidden" class="hide" name="token" id="token" value />
              </form>
              <div class="rights-content">
                <label>© {{currentYear}} ALL RIGHTS RESERVED &#124;</label>&nbsp;
                <span>KRID</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
